// extracted by mini-css-extract-plugin
module.exports = {"container":"e_u4","poster":"e_v4","player":"e_w4","play":"e_x4","playBadge":"e_y4","playIcon":"e_z4","loading":"e_A4","spin":"e_B4"};